import {
  SplitSupplyPartnerNoticeImportKind,
  SplitSupplyPartnerNoticeSkipReason,
} from '@ebalance/proto/bffuser/v1/split_supply_plan_model_pb'

import { issueReasonKeys } from '~/pages/SplitSupplyPlan/models/noticeImport'

/**
 * 他社の通告値の取込の画面側の決まり (文言の対応)。 ファイルの選択状態など自社の取込と共通のものは
 * `noticeImport.ts`。 読み取り・突合・誤りの判定は backend が持つ。
 */

export const PARTNER_IMPORT_KEY_PREFIX =
  'page:splitSupplyPlan.partner.import' as const

const KEY_PREFIX = PARTNER_IMPORT_KEY_PREFIX

/** 登録の種類 (新規 / 置き換え) → 文言の key。 */
export const IMPORT_KIND_KEYS: Record<
  SplitSupplyPartnerNoticeImportKind,
  string | undefined
> = {
  [SplitSupplyPartnerNoticeImportKind.UNSPECIFIED]: undefined,
  [SplitSupplyPartnerNoticeImportKind.NEW]: `${KEY_PREFIX}.kind.new`,
  [SplitSupplyPartnerNoticeImportKind.REPLACE]: `${KEY_PREFIX}.kind.replace`,
}

/** 取り込まない地点の理由 → 文言の key。 */
export const SKIP_REASON_KEYS: Record<
  SplitSupplyPartnerNoticeSkipReason,
  string | undefined
> = {
  [SplitSupplyPartnerNoticeSkipReason.UNSPECIFIED]: undefined,
  [SplitSupplyPartnerNoticeSkipReason.NOT_ELIGIBLE]: `${KEY_PREFIX}.skipped.reason.notEligible`,
  [SplitSupplyPartnerNoticeSkipReason.DUPLICATE_IN_ZIP]: `${KEY_PREFIX}.skipped.reason.duplicateInZip`,
  [SplitSupplyPartnerNoticeSkipReason.NOT_PARTY]: `${KEY_PREFIX}.skipped.reason.notParty`,
}

/** ファイルの誤りの理由 → 文言の key。 */
export const IMPORT_ISSUE_REASON_KEYS = issueReasonKeys(KEY_PREFIX)
